import React from 'react';
// import { Image } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import './ContentSection.scss';
import { LanguageConfig } from '../../../config/CustomEnums';
import ContentSections from '../../base/ContentSections';
import ContentLanguageCard from './ContentLanguageCard';
// const fieldsLanguages = [
//   LanguageConfig.english,
//   LanguageConfig.traditionalChinese,
//   LanguageConfig.simplifiedChinese,
// ];

// const detailPhotos = [
//   'detailPhotoOne',
//   'detailPhotoTwo',
//   'detailPhotoThree',
//   'detailPhotoFour',
// ];

function ContentSection({
  languages,
  data
}) {
  const { getValues } = useFormContext() || {};
  const campaign = data || getValues() || {};
  const translations = campaign.translations || {};
  // const { translations } = useSelector((state) => ({
  //   translations: state.createCampaign.campaign.translations,
  // }));
  // const showdown = require('showdown');
  // const converter = new showdown.Converter();

  // const fieldValueText = (value, index) => {
  //   return (
  //     <td
  //       key={`fieldValueText-${value}-${index}`}
  //       className="create-section-field-input"
  //       dangerouslySetInnerHTML={{
  //         __html: value ? converter.makeHtml(value) : '-',
  //       }}
  //     ></td>
  //   );
  // };

  // const fieldNameText = (value) => {
  //   return (
  //     <td className="create-section-label content-section-field-clumn">
  //       {value}
  //     </td>
  //   );
  // };

  // const fieldColumnText = (value) => {
  //   return (
  //     <th className="create-section-label content-section-value-clumn">
  //       {value}
  //     </th>
  //   );
  // };

  // const sectionValues = (valueKey) => {
  //   return (
  //     <>
  //       {fieldsLanguages.map((language, index) =>
  //         fieldValueText(translations[language][valueKey], index),
  //       )}
  //     </>
  //   );
  // };

  // const coverImage = () => {
  //   return (
  //     <>
  //       {fieldsLanguages.map((language, index) => (
  //         <td key={`coverImage-${language}-${index}`}>
  //           {translations[language].coverPhoto ? (
  //             <Image
  //               className="content-section-rectangle-image"
  //               src={translations[language].coverPhoto}
  //             />
  //           ) : (
  //             '-'
  //           )}
  //         </td>
  //       ))}
  //     </>
  //   );
  // };

  // const squareCoverImage = () => {
  //   return (
  //     <>
  //       {fieldsLanguages.map((language, index) => (
  //         <td key={`squareCoverImage-${language}-${index}`}>
  //           {translations[language].squareCoverPhoto ? (
  //             <Image
  //               className="content-section-square-image"
  //               src={translations[language].squareCoverPhoto}
  //             />
  //           ) : (
  //             '-'
  //           )}
  //         </td>
  //       ))}
  //     </>
  //   );
  // };

  // const getDetailPhotosWithOneLanguage = (language) => {
  //   const mapResult = detailPhotos.map((detailPhoto) =>
  //     translations[language][detailPhoto] ? (
  //       <Image
  //         key={`detail-photo-${language}-${translations[language][detailPhoto]}`}
  //         className="content-section-rectangle-image content-section-detail-photo"
  //         src={translations[language][detailPhoto]}
  //       />
  //     ) : null,
  //   );
  //   const deleteNullItem = mapResult.filter((result) => result);
  //   return deleteNullItem.length === 0 ? '-' : deleteNullItem;
  // };

  // const images = () => {
  //   return (
  //     <>
  //       {fieldsLanguages.map((language, index) => (
  //         <td key={`fieldsLanguages-${language}-${index}`}>
  //           <div className="content-section-detail-photo-container">
  //             {getDetailPhotosWithOneLanguage(language)}
  //           </div>
  //         </td>
  //       ))}
  //     </>
  //   );
  // };

  console.log("content campaign:", campaign.recurringMessage)
  const renderTabForLanguage = (language) => {
    return (
      <>
        <ContentLanguageCard
          campaignData={campaign}
          language={language}
        />
      </>
 
    )
  }

  // return (
  //   <>
  //     <label className="create-section-title">CONTENT</label>
  //     <PerfectScrollbar>
  //       <Table bordered className="content-section-table-container">
  //         <thead>
  //           <tr>
  //             {fieldNameText()}
  //             {fieldColumnText(LanguageTabTransLation.english)}
  //             {fieldColumnText(LanguageTabTransLation.traditionalChinese)}
  //             {fieldColumnText(LanguageTabTransLation.simplifiedChinese)}
  //           </tr>
  //         </thead>
  //         <tbody>
  //           <tr>
  //             {fieldNameText('Title')}
  //             {sectionValues('generalName')}
  //           </tr>
  //           <tr>
  //             {fieldNameText('Short description')}
  //             {sectionValues('shortDescription')}
  //           </tr>
  //           <tr>
  //             {fieldNameText('Cover Image')}
  //             {coverImage()}
  //           </tr>

  //           <tr>
  //             {fieldNameText('Square Cover Image')}
  //             {squareCoverImage()}
  //           </tr>

  //           <tr>
  //             {fieldNameText('Image')}
  //             {images()}
  //           </tr>

  //           <tr>
  //             {fieldNameText('Instruction section title')}
  //             {sectionValues('instructionSectionTitle')}
  //           </tr>

  //           <tr>
  //             {fieldNameText('Instruction section content')}
  //             {sectionValues('instructionSectionContent')}
  //           </tr>

  //           <tr>
  //             {fieldNameText('Detail section title')}
  //             {sectionValues('detailSectionTitle')}
  //           </tr>

  //           <tr>
  //             {fieldNameText('Detail section content')}
  //             {sectionValues('detailSectionContent')}
  //           </tr>
  //         </tbody>
  //       </Table>
  //     </PerfectScrollbar>
  //   </>
  // );
  return (
    <ContentSections
      hidePreview
      languageTabContent={{
        containers: languages?.map((item) => ({
          container: [renderTabForLanguage(item.code)],
          key: item.code,
          title: item.sourceName || item.name,
        }))
      }}
      activeSection={LanguageConfig.english}
      contentStyle="campaign-detail-language-content-sections"
    />
  );
}

const mapPropsToState = (state) => ({
  languages: state.language.allList,
})

export default connect(mapPropsToState)(ContentSection);
